export interface FaqItem {
  q: string;
  a: string;
}

export const faqList: FaqItem[] = [
  {
    q: "平台上的“瓜”是真的吗？可信度如何保证？",
    a: "热瓜雷达以“可溯源”为第一原则。凡标注为事实的内容，都会附上权威通报、当事人声明或可查证的公开信源；无法确证的部分会明确标注“传闻/待证实”，绝不把猜测当定论。我们不生产“瓜”，只把散落各处的信息按时间线重新摆好。",
  },
  {
    q: "内容会点名真实艺人并做价值评判吗？",
    a: "原则上以“事件类型与公共讨论价值”为主，聚焦同类剧情、行业规则与传播现象，而非针对具体个人的私生活窥探或人格攻击。我们反对网暴、反对断章取义，更反对任何形式的造谣与带节奏。",
  },
  {
    q: "同类盘点和对比分析的更新频率是怎样的？",
    a: "今日热榜实时滚动更新；系列事件时间线随事件进展持续跟进；对比分析手册与同类盘点每周至少新增 2-3 篇，并随新热点回溯补全旧样本，确保纵向与横向的“全景感”。",
  },
  {
    q: "我想投稿一个值得盘点的事件，该怎么做？",
    a: "欢迎通过“关于我们”页面的联系邮箱或留言区向我们投稿。投稿请尽量附上信源链接与关键时间节点，编辑核实后会将其纳入对应的盘点或对比专题，并注明线索来源。",
  },
  {
    q: "平台的文章可以转载或引用吗？",
    a: "非商业性的注明来源转载我们欢迎，转载时请保留作者与“热瓜雷达”署名并附原文链接；商业或自媒体二次创作使用前，请先通过联系邮箱取得授权。我们对事件时间线等原创梳理成果保留相应权利。",
  },
  {
    q: "为什么强调“拒绝网暴、冷静吃瓜”？",
    a: "网络热点更迭极快，但落到具体的人和家庭上往往是真实的代价。我们相信“吃瓜”的价值在于看清规律与真相，而不是成为伤害的放大器。理性看待、不信谣不传谣，是我们希望传递给每位读者的基本态度。",
  },
];